import { map_children,home_map_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxRealMap = {
  name: "cxRealMap",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "地图",
        children: home_map_children,
        group: "chart",
        type: "realMapComponent",
        // enable(params) {
        //   return params.admin
        // },
        sort: 70
      }
    ],
    portal: [
      {
        name: "地图",
        children: home_map_children,
        type: "realMapComponent",
        componentType: 'cxRealMap',
        group: "chart",
     // enable(params) {
        //   return params.admin
        // },
        sort: 70
      }
    ],
    bigScreen: [
      {
        name: "地图",
        children: map_children,
        type: "realMapComponent",
        group: "chart",
        sort: 50
      }
    ]
  },
  toolbars: [
    {
      name: "cxRealMap",
      label: "地图",
      comp: {
        realMapComponentData: () => import("./toolbars/map-options-data.vue"),
        realMapComponentSetting: () => import("./toolbars/map-options-setting.vue"),
        realMapComponentStyle: () => import("./toolbars/map-options-style.vue")
      }
    },
    {
      name: "realMapScatter",
      label: "散点层",
      comp: {
        realMapScatterComponentSetting: () => import("./toolbars/series/scatter-options-setting.vue"),
        realMapScatterComponentData: () => import("./toolbars/series/scatter-options-Data.vue")
      }
    },
    {
      name: "realMapHot",
      label: "热力层",
      comp: {
        realMapHotComponentSetting: () => import("./toolbars/series/hot-options-setting.vue"),
        realMapHotComponentData: () => import("./toolbars/series/hot-options-Data.vue")
      }
    },
    {
      name: "realMapLines",
      label: "飞线层",
      comp: {
        realMapLinesComponentSetting: () => import("./toolbars/series/lines-options-setting.vue"),
        realMapLinesComponentData: () => import("./toolbars/series/lines-options-Data.vue")
      }
    }
  ]
}

export default cxRealMap
